export const InterfaceMonitoringStatusPolicy = ({
	INV_SENDING_STATUS_SEND: "SENT",
	INV_SENDING_STATUS_POST: "POST",
	INV_SENDING_STATUS_OK: "OK",
	INV_SENDING_STATUS_REJECT: "REJECT",
	INV_SENDING_STATUS_ERROR: "ERROR",
	INV_SENDING_STATUS_RECEIVED: "RECEIVED",
})